import { Button } from "@circleco/compass/components/Button";
import { Drawer } from "@circleco/compass/components/Drawer";
import { TextArea } from "@circleco/compass/components/TextArea";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

interface RejectReasonDrawerProps {
  i18nRoot: string;
  isOpen: boolean;
  isRejecting: boolean;
  onDismiss?: () => void;
  onSubmit: (reason: string | null) => void;
}

/**
 * Mobile-shell counterpart of the reject-reason popover: a bottom sheet with
 * a "Note / Optional" header, the note textarea, and Cancel / Reject in the
 * footer. Cancel dismisses the sheet without rejecting.
 */
export const RejectReasonDrawer = ({
  i18nRoot,
  isOpen,
  isRejecting,
  onDismiss,
  onSubmit,
}: RejectReasonDrawerProps) => {
  const [reason, setReason] = useState("");
  const title = t([i18nRoot, "rejection_note_title"]);

  return (
    <Drawer.Root
      open={isOpen}
      onOpenChange={open => {
        if (!open) {
          onDismiss?.();
        }
      }}
    >
      <Drawer.Content aria-label={title}>
        <Drawer.Header
          title={title}
          subtitle={t([i18nRoot, "rejection_note_optional"])}
        />
        <div className="flex flex-col gap-6">
          <TextArea
            aria-label={t([i18nRoot, "moderation_note"])}
            rows={10}
            resize="none"
            placeholder={t([i18nRoot, "rejection_note_placeholder"])}
            value={reason}
            onChange={event => setReason(event.target.value)}
          />
          <div className="flex justify-end gap-2">
            <Button type="button" variant="secondary" onClick={onDismiss}>
              {t("cancel")}
            </Button>
            <Button
              type="button"
              variant="primary"
              disabled={isRejecting}
              onClick={() => onSubmit(reason || null)}
            >
              {t([i18nRoot, "reject"])}
            </Button>
          </div>
        </div>
      </Drawer.Content>
    </Drawer.Root>
  );
};
